import moment from 'moment';

const addMinutes = (date, minutes) => {
  return moment(date).add(minutes, 'minute').toDate();
};

export default addMinutes;
